import { createAction } from '@reduxjs/toolkit'
import { TToast } from 'domain/types'

export const setToastState = createAction<TToast>('toast/setToastState')
